import { Box, MenuItem, Select, TextField, Typography } from '@mui/material';

const countryCodes = [
    { code: '+1', label: 'EE.UU.' },
    { code: '+1', label: 'Canadá' },
    { code: '+52', label: 'México' },
    { code: '+502', label: 'Guatemala' },
    { code: '+503', label: 'El Salvador' },
    { code: '+504', label: 'Honduras' },
    { code: '+505', label: 'Nicaragua' },
    { code: '+506', label: 'Costa Rica' },
    { code: '+507', label: 'Panamá' },
    { code: '+509', label: 'Haití' },
    { code: '+53', label: 'Cuba' },
    { code: '+58', label: 'Venezuela' },
    { code: '+57', label: 'Colombia' },
    { code: '+56', label: 'Chile' },
    { code: '+55', label: 'Brasil' },
    { code: '+54', label: 'Argentina' },
    { code: '+595', label: 'Paraguay' },
    { code: '+598', label: 'Uruguay' },
    { code: '+591', label: 'Bolivia' },
    { code: '+51', label: 'Perú' },
    { code: '+592', label: 'Guyana' },
    { code: '+597', label: 'Surinam' },
    { code: '+596', label: 'Guayana Francesa' }
];

export const PhoneNumberInput = ({ code, setCode, number, setNumber }) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
        <Box display="flex" gap={1}>
            <Select
                value={code}
                onChange={(e) => setCode(e.target.value)}
                variant="outlined"
                displayEmpty
                renderValue={(selected) => selected}
                sx={{
                    minWidth: 120,
                    height: 56,
                    px: 1.5,
                    color: '#d1d5db', 
                    borderRadius: 1.5,
                    border: '1px solid #4b5563', 
                    '.MuiSvgIcon-root': { color: '#9ca3af' }, 
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                    '&:hover': {
                        borderColor: '#6b7280', 
                    },
                    '&.Mui-focused': {
                        borderColor: '#9ca3af', 
                    },
                }}
            >
            {countryCodes.map((item) => (
                <MenuItem
                    key={item.code}
                    value={item.code}
                    sx={{
                        backgroundColor: '#111827', 
                        color: '#d1d5db',
                        '&.Mui-selected': {
                            backgroundColor: '#374151', 
                            color: '#ffffff',
                        },
                    }}
                    >
                        {item.label} ({item.code})
                </MenuItem>
            ))}
            </Select>
            <TextField
                fullWidth
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                placeholder="Número de teléfono"
                variant="outlined"
                type="number" 
                className='input-no-spinner'
                inputProps={{
                    style: {
                        color: '#d1d5db', 
                        height: '56px',
                        padding: '0 12px',
                    },
                }}
                sx={{
                    borderRadius: 1.5,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#4b5563', 
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#6b7280', 
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#9ca3af', 
                    },
                }}
            />
      </Box>
    </Box>
  );
};
